<template>
    <q-page class="q-pa-md">
        <techship_portals_list ref="techship_portals_list"></techship_portals_list>
    </q-page>
</template>

<script>
    export { default } from './techshipportalsapplicationviewmodel-custom-screen.js'
</script>